import { useNavigate } from "react-router-dom";
import { IoLockClosed } from "react-icons/io5";
import Button from "./Button";

const UnAuthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center mt-8 pt-8 px-6">
      <div className="text-center">
        <IoLockClosed className="mx-auto mb-6 text-gray-300" size={80} />
        
        <h1 className="text-3xl font-bold text-gray-800 mb-4">
          You do not have permission to access this page
        </h1>
        
        <p className="text-gray-500 mb-8 text-lg">
          Access to this page is restricted to authorized administrators.
        </p>
        
        <Button
          variant="primary"
          onClick={() => navigate("/home")}
          className="px-8 py-3"
        >
          Go to home
        </Button>
      </div>
    </div>
  );
};

export default UnAuthorized;